export default
`
This piece represents male infertility. 1 in 6 couples worldwide suffer from infertility. Problems with sperm contribute towards more than 50% of infertility cases, but we have made startingly little progress in creating tools to understand sperm. \r\n

Current treatments are expensive, invasive, and are not very successful, placing a significantly unequal burden on women. Current research at the Centre for Human Reproductive Science at the University of Birmingham uses mathematical modelling, software development, and experiments to create new ways to diagnose and treat male infertility. \r\n

In this piece, half of the work is sperm and half is the female egg to represent that infertility is both a male and female issue. Inside the egg is an artistic representation of IVF. The mathematical equation represents how a sperm tail moves.

`


// WEBPACK FOOTER //
// ./src/content/male-infertility.js